<div class="container">
  <div class="text" [innerHTML]="alertText"></div>
  <div class="agree-button-div">
    <button class="alert-button agree-button" (click)="disableCookieAlert()">
      {{ alertButtonText }}
    </button>
    <button class="alert-button close-button" (click)="disableCookieAlert()">
      Fechar
    </button>
    <div>
      <button class="close-icon" (click)="disableCookieAlert()">X</button>
    </div>
  </div>
</div>
